<script setup>
// import { ref } from 'vue';
import StockProfileTable from "./Tables/StockProfileTable.vue";
import ArgonInput from "@/components/ArgonInput.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
</script>
<template>
<div class="py-4 container-fluid ">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header pb-0">
                <h6>Stock Profile</h6>
                </div>
                <div class="py-4 container-fluid">
                    <div class="row ">
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Item</label>
                            <input class="form-control" v-model="model.stockProfile.item" id="input_item" type="text" placeholder="Item..." />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Category</label>
                            <select class="form-control" v-model="model.stockProfile.category" >
                                <option value="0">Alat Nursery</option>
                                <option value="1">Racun</option>
                                <option value="2">Baja</option>
                                <option value="3">Spare Part</option>
                                <option value="4">Tanah</option>
                                <option value="5">Minyak</option>
                                <option value="6">Alat Kebun Sawit</option>
                                <option value="9">Others</option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Price (RM)</label>
                            <input class="form-control" v-model="model.stockProfile.price" id="input_price" type="number" placeholder="Price..." />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Supplier</label>
                            <input class="form-control" v-model="model.stockProfile.supplier" id="input_supplier" type="text" placeholder="Supplier..." />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Quantity</label>
                            <input class="form-control" v-model="model.stockProfile.quantity" id="input_quantity" type="text" placeholder="satu beg..." />
                        </div>
                        <div class="col-md-4">
                            <label for="example-text-input" class="form-control-label">Remark</label>
                            <argon-input type="text" id="input_remark" v-model="model.stockProfile.remark"  placeholder="Remark...." />
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-12">
                            <button class="btn btn-success " @click="addStockProfile" style="float: right;" id="btn_add">Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="mt-4 row">
        <div class="col-12">
            <StockProfileTable :key="componentKey" />
        </div>
    </div>
</div>
</template>


<script>
import axios from 'axios';

export default {
  name:'vehicleCreate',
  data(){
    return {
        componentKey: 0,
    //   errorList: '',
      model:{
        stockProfile:{
            item:'',
            category:'0',
            supplier:'',
            price:'',
            quantity:'',
            remark:''
        }
      },
    }
  },
  methods: {
    addStockProfile(){
        // console.log(this.model.stockProfile);
        // var mythis = this;
        axios.post('stock/addStockProfile',this.model.stockProfile)
            .then(res => {
                alert(res.data.message);
                this.model.stockProfile = {
                    item:'',
                    category:'0',
                    supplier:'',
                    price:'',
                    quantity:'',
                    remark:''
                };
                this.componentKey += 1;
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Vehicle No and type is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    }
    
  },
}
</script>
